import React from 'react';
import { BrandingPageLineItemProps } from './types';
import ConditionalLinkWrapper from 'src/scripts/templates/_shared/ui-components/ConditionalLinkWrapper';
import { prependLocaleToPath } from 'src/scripts/utils/localization';

const BrandingPageLineItem = ({ item }: BrandingPageLineItemProps) => {
  const { product_title, quantity, variant_title, image_url, is_clickable, product_handle } = item;
  const productUrl = product_handle ? `${prependLocaleToPath('/products')}/${product_handle}` : null;
  return (
    <div className="line-item-row d-flex">
      <div className="line-item-image mr-md">
        <ConditionalLinkWrapper
          isClickable={is_clickable}
          productUrl={productUrl}
          ariaLabel={`View details for ${product_title}`}
        >
          <img
            src={image_url || '/cdn/shop/files/Missing_Image_200x.png?v=8684511414166916069'}
            alt={product_title}
            onError={(e) => {
              e.currentTarget.src = 'https://cdn.shopify.com/s/files/1/2185/2813/files/Missing_Image.png?v=1757010819';
            }}
          />
        </ConditionalLinkWrapper>
      </div>
      <div className="item-details d-flex flex-column justify-content-center">
        <ConditionalLinkWrapper
          isClickable={is_clickable}
          productUrl={productUrl}
          ariaLabel={`View details for ${product_title}`}
        >
          <p className="body semibold">
            {product_title} x {quantity}
          </p>
        </ConditionalLinkWrapper>
        <p className="item-variant body semibold">{variant_title}</p>
      </div>
    </div>
  );
};

export default BrandingPageLineItem;
